import { Box } from '@mui/material'
import DefaultAddressSearch from 'components/Common/AddressSearch/AddressSearch'
import SectionHeader from 'components/Common/SectionHeader'
import { Controller } from 'react-hook-form'

type AddressSearchProps = {
  name: string
  clientId: number
  control?: any
  id?: string
  label: string
  populateFixedRoute: any
}

const AddressSearch = ({
  name,
  clientId,
  control,
  label,
  id,
  populateFixedRoute,
}: AddressSearchProps) => {
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        gap: '20px',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <SectionHeader
        title={label}
        containerStyles={{
          alignSelf: 'center',
          marginBottom: '0',
          minWidth: '100px',
        }}
      />
      <Box
        component={'div'}
        sx={{
          flexGrow: '1',
          height: '56px',
          display: 'flex',
          alignItems: 'stretch',
        }}
      >
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange } }) => {
            return (
              <DefaultAddressSearch
                onAddresssSelected={(location, id) => {
                  if (location['fixedRoute'] !== undefined) {
                    populateFixedRoute(location.fixedRoute)
                  } else {
                    onChange({
                      ...location,
                      id,
                    })
                  }
                }}
                addressPlaceholder={label}
                id={id}
                name={name}
                clientId={clientId}
                defaultValue={{
                  value: value,
                  label: value?.formattedAddress,
                }}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    height: 56,
                  }),
                  container: (provided: any) => ({
                    ...provided,
                    flexGrow: '1',
                  }),
                  menu: (provided: any) => ({
                    ...provided,
                  }),
                }}
              />
            )
          }}
        />
      </Box>
    </Box>
  )
}

export default AddressSearch
